module.exports = __webpack_public_path__ + "img/0-your-pension-thumbnail.2d4985a6.png";